export default "__VITE_ASSET__39fa2144__"